import React from 'react'
import { Button, Form, Row, Col, Table } from '@themesberg/react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faRedoAlt } from '@fortawesome/free-solid-svg-icons'
import useWithdrawRequestList from './hooks/useWithdrawRequestList'
import PaginationComponent from '../Pagination'
import DateRangePicker from '../DateRangePicker'
import ClientFilter from '../ClientFilter'
import PortalFilter from '../PortalFilter'
import Trigger from '../OverlayTrigger'
import { formatDateYMD } from '../../utils/dateFormatter'

export default ({ type }) => {
  const {
    limit,
    page,
    name,
    status,
    state,
    setState,
    paymentProvider,
    withdrawRequests,
    setLimit,
    setPage,
    setName,
    setStatus,
    setPaymentProvider,
    loading,
    totalPages,
    selectedPortal,
    setSelectedPortal,
    setSelectedClient,
    selectedClient,
    resetFilter,
    getStatus,
    isSuperAdmin
  } = useWithdrawRequestList({ type })

  return (
    <>
    <div className='section-header-wrap mt-n3 mx-n3'>
      <Row>
        <Col>
          <h2 className='title-text'>Withdraw Requests</h2>
        </Col>
      </Row>
      </div>
      <div className='FormsBg'>
      <Row>
        <Col xs={3} >
          {/* <Form.Label column='sm' className='mx-auto text-nowrap px-2'>
            Search
          </Form.Label> */}

          <Form.Control
            size='sm'
            type='search'
            value={name}
            placeholder='Search Name,Email'
            onChange={(e) =>
              setName(e.target.value.replace(/[~`!$%^&*#=)()><?]+/g, ''))}
          />
        </Col>
        <Col xs={3} >
          {/* <Form.Label column='sm' className='mx-auto text-nowrap px-2'>
            Payment Provider
          </Form.Label> */}

          <Form.Control
            size='sm'
            type='search'
            value={paymentProvider}
            placeholder='Search Payment Provider'
            onChange={(e) =>
              setPaymentProvider(
                e.target.value.replace(/[~`!$%^&*#=)()><?]+/g, '')
              )}
          />
        </Col>

        <Col xs={2} >
          {/* <Form.Label column='sm' className='mx-auto text-nowrap px-2'>
            Status
          </Form.Label> */}

          <Form.Select
            size='sm'
            // style={{ maxWidth: '230px' }}
            onChange={(e) => setStatus(e.target.value)}
            value={status}
          >
            <option value=''>All</option>

            <option key='pending' value='0'>
              Pending
            </option>
            <option key='approved' value='5'>
              Approved
            </option>
            <option key='cancelled' value='2'>
              Cancelled
            </option>
          </Form.Select>
        </Col>
        {isSuperAdmin && (
          <>
            <Col xs={2}>
              <ClientFilter
                setSelectedClient={setSelectedClient}
                setSelectedPortal={setSelectedPortal}
                selectedClient={selectedClient}
              />
            </Col>

            {selectedClient && (
              <Col xs={2}>
                <PortalFilter
                  setSelectedPortal={setSelectedPortal}
                  selectedPortal={selectedPortal}
                  selectedClient={selectedClient}
                />
              </Col>
            )}
          </>
        )}

        <Col
          xs={3}
        >
          {/* <Form.Label column='sm' className='mx-auto text-nowrap px-2'>
            Time Period
          </Form.Label> */}
          <DateRangePicker state={state} setState={setState} size='sm' />
        </Col>
        <Col xs={1} >
        <div className='d-flex justify-content-end align-item-center'>

          <Trigger message='Reset Filters'>
            <Button
              className=''
              size='sm'
              onClick={() => {
                resetFilter()
              }}
            >
              <FontAwesomeIcon icon={faRedoAlt} />
            </Button>
          </Trigger>
          </div>
        </Col>
      </Row>
      </div>
      <div className='TableBg mt-4 pt-1'>
      
      <Table
        striped
        responsive
        hover
        size='sm'
        className='text-center mt-3'
      >
        <thead className='thead-light'>
          <tr>
            {[
              'Id',
              'Email',
              'Name',
              'Amount',
              'Payment Provider',
              'Transaction Id',
              'Status',
              'Actionable Type',
              'Updated At'
            ].map((c) => (
              <th key={c} className={`${['Amount'].includes(c) && withdrawRequests?.count > 0 ? 'text-right' : ''}`}>{c}</th>
            ))}
          </tr>
        </thead>

        <tbody id={loading ? 'cover-spin' : ''}>
          {Boolean(withdrawRequests) && !loading &&
                withdrawRequests?.rows?.map(
                  ({
                    withdrawRequestId,
                    userId,
                    status,
                    name,
                    amount,
                    transactionId,
                    actionableType,
                    paymentProvider,
                    updatedAt,
                    email,
                    User
                  }) => {
                    return (
                      <tr key={withdrawRequestId}>
                        <td>{userId}</td>
                        <td>{email}</td>
                        <td>{name}</td>
                        <td className='text-right'>{amount} {User?.currencyCode}</td>
                        <td>{paymentProvider || 'NA'}</td>
                        <td>{transactionId}</td>
                        <td>{getStatus(status)}</td>
                        <td>{actionableType || 'NA'}</td>
                        <td>{formatDateYMD(updatedAt) || 'NA'}</td>
                      </tr>
                    )
                  }
                )}

          {withdrawRequests?.count === 0 && !loading && (
            <tr>
              <td colSpan={9} className='text-danger text-center'>
                No data found
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      {withdrawRequests?.count !== 0 && !loading && (
        <PaginationComponent
          page={withdrawRequests?.count < page ? setPage(1) : page}
          totalPages={totalPages}
          setPage={setPage}
          limit={limit}
          setLimit={setLimit}
        />
      )}
      </div>
      
    </>
  )
}
